<div class="input-grid-gaps grid-2col">
    <app-radio-input [form]="form" id="type" [staticOptions]="types" [autoSelectFirst]="true"
        [prefix]="prefix"></app-radio-input>
    <app-check-input [form]="form" id="oneTime" [prefix]="prefix"></app-check-input>
    <app-text-input [form]="form" id="mobile" [prefix]="prefix"></app-text-input>
    <div></div>
    <app-text-input [form]="form" id="mail" [prefix]="prefix"></app-text-input>
    <app-button label="ePrescriptions.notificationSend.buttons.storeToPersonData"></app-button>
</div>

<div #dialogFooter class="p-dialog-footer">
    <div class="flex dialogButtons-fullWidth">
        <app-button label="ePrescriptions.notificationSend.buttons.setOneTime"></app-button>
        <app-button label="ePrescriptions.notificationSend.buttons.setPermanent"></app-button>
    </div>
</div>
